import { DefaultFolderEmoji } from '../DefaultFolderEmoji/DefaultFolderEmoji'
import { memo } from 'react'

export const FolderEmoji = memo(({ emoji, className }: { emoji: string | null; className?: string }): JSX.Element => {
  if (emoji) return <span className={className}>{emoji}</span>

  return <DefaultFolderEmoji className={className} />
})
